declare namespace $ {

	type $mol_link__uri_shm_projects_catalog_head_1 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog_head['title_uri'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__title_shm_projects_catalog_head_2 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog_head['title'] >
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_view__sub_shm_projects_catalog_head_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_projects_catalog_head extends $shm_list_head {
		title_uri( ): string
		Title( ): $mol_link
		add_content( ): readonly(any)[]
		Controls( ): $mol_view
	}
	
}

//# sourceMappingURL=head.view.tree.d.ts.map